export default "__VITE_ASSET__J_mngnto__"